import React, { createContext, useState } from "react";

export const SVTUserContext = createContext();

export const SVTUserProvider = ({ children }) => {
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [activeTab, setActiveTab] = useState("Tab1");
    const [activeLevelId, setActiveLevelId] = useState(null);
    const [assessmentId, setAssessmentId] = useState(null);
    const [assessmentResult, setAssessmentResult] = useState(null);
    const [templateName, setTemplateName] = useState("");
    const [isReview, setIsReview] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [assessmentResponses, setAssessmentResponses] = useState([]);
    const [assessmentQuestions, setAssessmentQuestions] = useState([]);
    const [scores, setScores] = useState({
        basicScore: 0,
        developingScore: 0,
        matureScore: 0,
        aggregateScore: 0,
    });
    const [isGuidelinesModalOpen, setIsGuidelinesModalOpen] = useState(false);

    return (
        <SVTUserContext.Provider
            value={{
                selectedEntity,
                setSelectedEntity,
                activeTab,
                setActiveTab,
                activeLevelId,
                setActiveLevelId,
                assessmentId,
                setAssessmentId,
                assessmentResult,
                setAssessmentResult,
                templateName,
                setTemplateName,
                isReview,
                setIsReview,
                isSave,
                setIsSave,
                assessmentResponses,
                setAssessmentResponses,
                assessmentQuestions,
                setAssessmentQuestions,
                scores,
                setScores,
                isGuidelinesModalOpen,
                setIsGuidelinesModalOpen,
            }}
        >
            {children}
        </SVTUserContext.Provider>
    );
};
